import '../../style/base.css';
import '../index.css';


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/tab/style/index.js
// module id = 184
// module chunks = 31